import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { logoutAll } from '../api';

export function LogoutAllButton() {
  const qc = useQueryClient();
  const [message, setMessage] = useState<string | null>(null);
  const mutation = useMutation({
    mutationFn: logoutAll,
    onSuccess: (data) => {
      const n = data.revokedSessions;
      setMessage(
        n === 0
          ? 'Aucune autre session active à terminer.'
          : n === 1
            ? '1 autre session active a été terminée.'
            : `${n} autres sessions actives ont été terminées.`,
      );
      qc.invalidateQueries({ queryKey: ['my-auth-events'] });
      qc.invalidateQueries({ queryKey: ['my-devices'] });
    },
    onError: (err) =>
      setMessage(err instanceof Error ? err.message : 'Impossible de vous déconnecter partout.'),
  });

  return (
    <section className="rounded-3xl bg-gradient-to-br from-red-50 via-white to-amber-50/90 p-[1px] shadow-sm shadow-red-900/15 ring-1 ring-red-200/80">
      <div className="rounded-[calc(1.5rem-1px)] px-8 py-8 sm:flex sm:flex-wrap sm:items-start sm:justify-between sm:gap-6">
        <div className="max-w-xl">
          <h3 className="text-lg font-semibold tracking-tight text-red-950">
            Déconnexion ailleurs
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-red-950/70">
            Révoquez toutes les autres sessions renouvelables — utile si vous avez perdu un
            appareil.
          </p>
        </div>
        <button
          type="button"
          className="btn-danger mt-6 shrink-0 sm:mt-0"
          disabled={mutation.isPending}
          onClick={() => mutation.mutate()}
        >
          {mutation.isPending ? 'Traitement…' : 'Révoquer les autres sessions'}
        </button>
      </div>
      {message && (
        <p
          className={`mx-px mb-px rounded-b-[calc(1.5rem-1px)] border-t px-8 py-3 text-sm ${
            mutation.isSuccess
              ? 'border-emerald-100 bg-emerald-50 text-emerald-950'
              : 'border-red-100 bg-white text-red-900'
          }`}
        >
          {message}
        </p>
      )}
    </section>
  );
}
